import styled, { css } from 'styled-components';

export const Container = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    color: ${theme.v2.colors.neutral.lowDark};
    gap: 24px;
  `}
`;

export const Title = styled.span`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.sm};
    font-weight: ${theme.v2.font.weights.medium};
  `}
`;

export const Message = styled.span`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.xs};
    color: ${theme.v2.colors.neutral.lowDark};
  `}
`;

export const RebootInfo = styled.div`
    display: flex;
    flex-direction: column;
`;

export const InfoRow = styled.div`
  ${({ theme }) => css`
    display: flex;
    gap: 24px;
    padding: 16px;
    border-bottom: 1px solid ${theme.v2.colors.neutral.highMedium};
  `}
`;

export const Info = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    width: 83px;
`;

export const InfoName = styled.span`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.medium};
    color: ${theme.v2.colors.neutral.lowMedium};
  `}
`;

export const InfoValue = styled.span`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.regular};
  `}
`;

export const Actions = styled.div`
  display: flex;
  justify-content: center;
`;
